import { Component, Input, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { CartService } from 'src/app/core/services/cart.service';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { WalletService } from 'src/app/core/services/wallet.service';
import { ErrorMessageComponent } from '../all-modals/error-message/error-message.component';
import { PaymentDeclinedComponent } from '../all-modals/payment-declined/payment-declined.component';
import { SuccessMessageComponent } from '../all-modals/success-message/success-message.component';
import { RemoveContent } from '../private-library/remove-content/remove-content.component';
import { AddTokensComponent } from '../wallet/add-tokens/add-tokens.component';
import { environment } from 'src/environments/environment';
import { AuthService } from './../../core/services/auth.service';
import { UploadSpaceModalComponent } from '../wipod/upload-publication/upload-space-modal/upload-space-modal.component';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit {

  @Input() contentId;
  @Input() walletRedirect;
  cartItems: [];
  grayedCount = 0;
  purchasedContents = [];
  isError: boolean = false;
  errorMessage: string;
  userData: any;
  allCartItems;
  finalCartItems;
  total;
  userTokens: any;
  isemplty: boolean = true;
  imgPath: string = environment.url
  tokenError;
  isSupplementary: boolean;
  notPurchasable = [];
  isBulkConsume;
  isUpdateCart = true;
  cartValue: boolean;
  oldQuantity: any = [];
  contentLoader: boolean = false;
  isFormValid: boolean = true;

  constructor(
    private modalService: NgbModal,
    private activeModal: NgbActiveModal,
    private _cartService: CartService,
    private _spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService,
    private _walletService: WalletService,
    private _router: Router,
    private _authService: AuthService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.oldQuantity = [];
    this.isSupplementary = this._authService.isSupplementaryAccount();
    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS);
    if (this.userData)
      this.getAllCartItems(false);
    this.isBulkConsume = this.userData.user.subscription.plan.can_bulk_consume;
    this.loadTokens();
    if (this.walletRedirect) {
      this.checkRecentTransaction();
    }
  }

  getAllCartItems(submitcart) {
    if (submitcart)
      this.checkCart();

    if (this.isBulkConsume && !this.isUpdateCart && submitcart) {
      // const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      // modalRef.componentInstance.title = 'Attention!';
      // modalRef.componentInstance.message = 'Please update your cart before buying content(s)';
      const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
      modalRef.componentInstance.contentAccessError = 'Please update your cart before buying content(s)';
      modalRef.componentInstance.isRedirectRequired = false;
      return;
    }
    this.contentLoader = true;
    this._cartService.allCartItemsCopy().subscribe((response: any) => {
      this.notPurchasable = [];
      if (response.success) {
        if (!submitcart) {
          this.grayedCount = 0;
          this.contentLoader = false;
        }
        let grayedCount = 0;
        this.allCartItems = response.data.cart_items;

        // this.oldQuantity = [];
        this.allCartItems.map((val, i) => {
          if (!val.purchasable) {
            this.notPurchasable.push(val.recordable.out_line);
          }
          if (val.recordable.total_tokens) {
            val.amount = val.recordable.total_tokens;
          }
          else if (val.tokens_amount) {
            val.amount = val.quantity * val.tokens_amount
          }
          else if (val.recordable.tokens) {
            val.amount = val.quantity * val.recordable.tokens
          }
          if (this.oldQuantity.length == 0)
            this.oldQuantity[i] = val.quantity;
        })
        this.allCartItems.map(val => {
          if (val.recordable.total_tokens) {
            val.amount = val.recordable.total_tokens;
          }
          else if (val.tokens_amount) {
            val.tokens = val.tokens_amount;
          }
          else if (val.recordable.tokens) {
            val.tokens = val.recordable.tokens;
          }

        });
        const isSupplementary = this.isSupplementary;
        if (this.isBulkConsume) {
          this.allCartItems.map((val) => {
            if (val.recordable_type == 'Advertisement') {
              val.tokens_amount = val.recordable.total_tokens;
            } else {
              val.tokens = val.tokens_amount;
            }
          })
          // current.recordable.content_owner_add_on_expire ||
          this.total = this.allCartItems.reduce(function (previous, current) {
            if ((!current.is_sender_verified || current.recordable.creator_library_type != 'public' ||
              (isSupplementary && current.recordable.adult_content)) && !current.recordable.label) {
              grayedCount += 1;
              return previous;
            } else {
              return previous + current.tokens_amount;
            }
          }, 0);
        } else {
          this.total = this.allCartItems.reduce(function (previous, current) {
            if ((!current.is_sender_verified || current.recordable.creator_library_type != 'public' ||
              (isSupplementary && current.recordable.adult_content)) && !current.recordable.label) {
              grayedCount += 1;
              return previous;
            } else {
              return previous + current.amount;
            }
          }, 0);
        }
        var result = [];
        this.allCartItems.reduce(function (res, value) {

          if (!res[value.id]) {
            res[value.id] = {
              recordable_id: value.id, recordable_type: value.recordable_type, content: value.recordable
              , quantity: 0, tokens: 0, is_sender_verified: value.is_sender_verified, is_valid: true, error: ''
            };
            result.push(res[value.id])
          }
          if (value.slot) {
            res[value.id].slot = '(' + value.slot.slot_no + ')';
          }
          res[value.id].quantity += value.quantity;
          res[value.id].tokens += value.tokens;
          return res;
        }, {});
        this.finalCartItems = [...result];

        if (!submitcart) {
          this.grayedCount = grayedCount;
        } else {
          if (grayedCount != this.grayedCount) {
            this.grayedCount = grayedCount;
            this.contentLoader = false;
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.title = "Attention!";
            modalRef.componentInstance.message = "Your cart content has been updated. Please check again before buying it.";
          } else {
            this.purchasedContent();
          }
        }
      }
    })
  }

  loadTokens() {
    // return;
    this._walletService.loadTokens().subscribe(
      (response: any) => {
        if (response.success) {
          this.userTokens = response.data.account;
        }
      })
  }

  purchasedContent() {
    if (this.notPurchasable.length) {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.CART_ALREADY_BOUGHT_CONTENT.replace('<Content name>', this.notPurchasable.join(', '));
      this.contentLoader = false;
      return;
    }

    this.tokenError = "";
    if (this.userTokens == undefined || this.userTokens.total_tokens == 0 || this.userTokens.total_tokens < this.total) {
      // const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      this.tokenError = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_ADD_TOKEN_BEFORE_PURCHASE;
      // modelRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_ADD_TOKEN_BEFORE_PURCHASE;
      this.contentLoader = false;
      this.scrollToFirstInvalidControl();
      return;
    }
    else {
      this._cartService.purchasedContent().subscribe((response: any) => {
        this.contentLoader = false;
        if (response.success) {
          this.closeDialog();
          this.finalCartItems = [];
          this.purchasedContents = response.data.purchased_contents;
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = "Content purchased successfully";
        }
        else {
          this.errorMessage = response.message;
          this.isError = true;
          // this._toastr.warning('Something Went Wrong');
        }
      }, (error: any) => {
        const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modelRef.componentInstance.message = error;
        // this._toastr.warning(error);
        this._spinner.hide();
        this.errorMessage = error;
        this.isError = true;
      });
    }
  }

  clearCart() {
    const modalRef = this.modalService.open(RemoveContent, { centered: true });
    modalRef.componentInstance.title = "Clear Cart";
    modalRef.componentInstance.message = "Are you sure you want to remove all content from cart?";
    modalRef.componentInstance.successActionButtonName = "Remove";
    modalRef.result.then((response) => {
      if (response === 'success') {
        this._spinner.show();
        this._cartService.clearCart().subscribe((response) => {
          this._spinner.hide();
          if (response.success) {
            this.ngOnInit();
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.CLEAR_CART;
          } else {
            const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modelRef.componentInstance.message = "Error occured during clearing cart!";
          }
        })
      }
    });

  }

  exploreScriptdoor() {
    this._router.navigate(['/']);
    this.closeDialog();
  }

  addMore() {
    // return;
    const modalRef = this.modalService.open(AddTokensComponent, { size: 'lg', centered: true, windowClass: 'add-token' });
    modalRef.componentInstance.sourceCart = 'cart';
    if (this.total >= this.userTokens.total_tokens)
      modalRef.componentInstance.inputTokens = Math.ceil(this.total - this.userTokens.total_tokens);
    // this._router.navigate(['/material-detail-page', this.contentId], { queryParams: { source: 'cart' } })

    // modalRef.result.then((result) => {
    //   this.ngOnInit();
    // }, (reason) => {
    // });
  }

  removeItemFromCart(data) {

    const modalRef = this.modalService.open(RemoveContent, { centered: true });
    modalRef.componentInstance.title = "Remove Content";
    modalRef.componentInstance.message = "Are you sure you want to remove this content from cart?";
    modalRef.componentInstance.successActionButtonName = "Remove";
    modalRef.result.then((response) => {
      if (response === 'success') {
        this._spinner.show();
        this._cartService.removeItemFromCart(data.recordable_id).subscribe((response) => {
          this._spinner.hide();
          if (response.success) {
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.REMOVE_SINGLE_ITEM;
            this.ngOnInit();
          } else {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.REMOVE_SINGLE_ITEM;
          }
        }, (error) => {
          this._spinner.hide();
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.REMOVE_SINGLE_ITEM;
        });
      }
    });
  }

  closeDialog() {
    this.activeModal.close(this.purchasedContents);

    if (document.body.classList.contains('show-shoping-modal')) {
      document.body.classList.remove("show-shoping-modal");
    } else {
      document.body.classList.add("show-shoping-modal");
    }
  }

  checkRecentTransaction() {
    this._cartService.recentTransactionDetails().subscribe((response) => {
      if (response.success) {
        if (response.data.recent_payment_status == 'pending') {
          const modalRef = this.modalService.open(PaymentDeclinedComponent, { centered: true });
          modalRef.componentInstance.title = "Transaction Pending!";
          modalRef.componentInstance.message = "Sorry, Your transaction has been pending due to some technical issues. We are updating your transaction within 5-10 minutes. Please check your transaction status in the wallet section.";
        }
        // else if (response.data.recent_payment_status == 'failure') {
        //   const modalRef = this.modalService.open(PaymentDeclinedComponent, { centered: true });
        //   modalRef.componentInstance.title = "Payment Failure!";
        //   modalRef.componentInstance.message = "Sorry, We are unable to process your payment at this time. Please try again later.";
        // }
      }
    })
  }

  addQuantity(data, index) {
    data.quantity = (+data.quantity) + 1;
    if (data.quantity) {
      data.is_valid = true;
      data.error = '';
    }
    this.isUpdateCart = false;
    // this.checkCart();
  }

  removeQuantity(data, index) {
    if (data.quantity > 1) {
      data.quantity = (+data.quantity) - 1;
      if (data.quantity) {
        data.is_valid = true;
        data.error = '';
      }
      this.isUpdateCart = false;
      // this.checkCart();
    }
  }

  restrictNumeric(event) {
    if (event.target.value.length > 11 || event.charCode == 46 || event.charCode == 101 || (event.charCode == 48 && (event.target.value == '' || event.target.value == 0) || event.charCode == 45 || event.charCode == 43)) {
      return false;
    }
  }

  restrictNumericPaste(data, index, event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");
    let duration_number = (event.target.value) ? (event.target.value.toString() + filteredText) : (filteredText > 0 ? filteredText : '');
    this.finalCartItems[index].quantity = data.quantity = (duration_number ? (+duration_number.substring(0, 12)) : '');
    if (filteredText > 0) {
      data.is_valid = true;
      data.error = '';

      this.isUpdateCart = false;
    }
    event.preventDefault();
    //   this.checkCart();
  }

  changeQuantity(data, index, event) {
    if (!event.value) {
      event.value = data.quantity = this.oldQuantity[index];
      // event.value = data.quantity = this.cartValue ? this.cartValue : this.allCartItems[index].quantity;
    }
  }

  updateQuantity(data, index, event) {
    if (this.allCartItems[index].quantity) {
      this.cartValue = this.allCartItems[index].quantity
    }
    if (+data.quantity !== +event.value) {
      this.allCartItems[index].quantity = event.value ? (+event.value) : '';
      data.quantity = event.value ? (+event.value) : '';
      if (data.quantity) {
        data.is_valid = true;
        data.error = '';
      }
      this.isUpdateCart = false;
    }
    else {
      this.isUpdateCart = true;
    }
    this.checkCart();
  }

  checkCart() {
    let hasError = false;

    this.finalCartItems.every(
      (element) => {
        if (element.quantity && +element.quantity > 0) {
          // this.isUpdateCart = false;
          this.isFormValid = true;
          return true
        }
        else {
          element.is_valid = false;
          element.error = 'Please enter QTY';
          // this.isUpdateCart = true;
          hasError = true;
          this.isFormValid = false;
          return true;
        }
      });

    return hasError;
    // this.isUpdateCart = event.value && +event.value > 0 ? false : true;
    // if (+event.value < 1 || isNaN(+event.value)) {
    //   data.quantity = 1;
    //   event.value = 1;
    //   this.allCartItems[index].quantity = 1;
    // }
  }

  updateCart() {
    if (this.checkCart()) {
      this.scrollToFirstInvalidControl();
      return;
    }
    else {
      this.isUpdateCart = true;
      // this.contentLoader = true;
      this._spinner.show();
      const updateCartItems = [];
      this.allCartItems.forEach((element, i) => {
        const obj = {
          quantity: '',
          cart_id: '',
          recordable_type: '',
          recordable_id: ''
        };
        obj.quantity = this.finalCartItems[i].quantity;
        obj.cart_id = element.id;
        obj.recordable_id = element.recordable.id;
        obj.recordable_type = element.recordable_type;
        updateCartItems.push(obj);

        this.oldQuantity[i] = this.finalCartItems[i].quantity;
      });
      const formData = new FormData();
      updateCartItems.forEach((element, i) => {
        formData.append(`cart_items[${i}][quantity]`, element.quantity);
        formData.append(`cart_items[${i}][cart_id]`, element.cart_id);
        formData.append(`cart_items[${i}][recordable_id]`, element.recordable_id);
        formData.append(`cart_items[${i}][recordable_type]`, element.recordable_type);
      });
      this._cartService.updateCart(formData).subscribe((response) => {
        // this.contentLoader = false;
        this._spinner.hide();
        if (response.success) {

          if (response.data.failed_cart_items && response.data.failed_cart_items.length) {
            this.isUpdateCart = false;
            // if (response.data.failed_cart_items.length > 1) {
            this.finalCartItems.map((val, i) => {
              val.quantity = this.oldQuantity[i];
            });
            this.finalCartItems.map((val) => {
              val.error = '';
              val.is_valid = true;
              response.data.failed_cart_items.forEach((element) => {
                if (element.cart_item.id == val.recordable_id) {
                  val.error = element.message;
                  val.is_valid = false;
                }
              });
            });
            this.scrollToFirstInvalidControl();
            return;
            // }
            // else {
            //   message = `${response.data.failed_cart_items[0].cart_item_name}`;
            // }

            // if (message.includes(',')) {
            //   message = message.substr(1);
            // }

            // if (response.data.failed_cart_items[0].message.includes('within range')) {
            //   const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            //   modalRef.componentInstance.contentAccessError = response.data.failed_cart_items[0].message.replace('Quantity', `Quantity of ${message}`);
            //   return;
            // }
          }
          else {
            this.isUpdateCart = true;
            const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modalRef.componentInstance.message = "Cart updated successfully.";
          }
          this.getAllCartItems(false);
        }
      }, err => {
        this.isUpdateCart = false;
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = "Something went wrong.";
      });
    }
  }

  scrollToFirstInvalidControl() {
    // this.finalCartItems.every((element) => {
    // if (!element.is_valid) {
    setTimeout(() => {
      const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(".invalid-control");
      firstInvalidControl.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }, 10);
    // return false;
    // }
    // return true;
    // });
  }
}
